import React from "react";
import NumberFormat from "react-number-format";
import { getTopicBadgeColor } from "../../../../helper";
import "../../index.scss";
import { EmptyState } from "../../../../../../../../Packages/EmptyState";

export default class DriverDataView extends React.Component {
  render() {
    return (
      <>
        <h3 className="global-h3">{this.props.title}</h3>
        {this.props.data.length!==0 ? (
          <>
            {this.props.data &&
              this.props.data.map((item) => (
                <>
                  <li>
                    <span
                      className={`item-count ${getTopicBadgeColor(
                        item.favScore * 100
                      )}`}
                    >
                      <NumberFormat
                        value={item.favScore * 100}
                        decimalScale={0}
                        displayType="text"
                      />
                    </span>
                    <div className="item-info">
                      <span className="item-info__text">{item.item}</span>
                      <span className="item-info__dimension">
                        {item.dimension}
                      </span>
                    </div>
                  </li>
                </>
              ))}
          </>
        ) : (
          <EmptyState
            emptyStateMessage={"No data found"}
          />
        )}
      </>
    );
  }
}
